import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const ContactSupport = () => {
  const [ticketForm, setTicketForm] = useState({
    subject: '',
    category: '',
    description: '',
    priority: 'normal'
  });

  const supportOptions = [
    {
      id: 'live-chat',
      title: 'Live Chat',
      description: 'Get instant help from our support team',
      availability: 'Available 9 AM - 6 PM EST',
      icon: 'MessageCircle',
      color: 'bg-blue-500/10 text-blue-500'
    },
    {
      id: 'submit-ticket',
      title: 'Submit a Ticket',
      description: 'Send us a detailed support request',
      availability: 'Response within 24 hours',
      icon: 'Mail',
      color: 'bg-purple-500/10 text-purple-500'
    },
    {
      id: 'schedule-call',
      title: 'Schedule Consultation',
      description: '1-on-1 session with our experts',
      availability: 'Premium subscribers only',
      icon: 'Phone',
      color: 'bg-green-500/10 text-green-500'
    },
    {
      id: 'community',
      title: 'Skool Community',
      description: 'Connect with other authors',
      availability: 'Enterprise plan members',
      icon: 'Users',
      color: 'bg-orange-500/10 text-orange-500'
    }
  ];

  const handleSubmitTicket = (e) => {
    e?.preventDefault();
    console.log('Ticket submitted:', ticketForm);
    // Handle ticket submission
  };

  return (
    <div className="bg-gradient-to-br from-primary/5 to-primary/10 rounded-2xl p-8 lg:p-12">
      <div className="text-center mb-12">
        <h2 className="text-3xl font-heading font-bold text-foreground mb-3">
          Still Need Help?
        </h2>
        <p className="text-muted-foreground">
          Our support team is here to assist you with any questions or issues
        </p>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
        {supportOptions?.map((option) => (
          <button
            key={option?.id}
            className="bg-card border border-border rounded-xl p-6 text-left hover:shadow-lg transition-all group"
          >
            <div className={`w-12 h-12 ${option?.color} rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`}>
              <Icon name={option?.icon} size={24} />
            </div>
            <h3 className="text-lg font-heading font-bold text-foreground mb-2">
              {option?.title}
            </h3>
            <p className="text-sm text-muted-foreground mb-3">
              {option?.description}
            </p>
            <p className="text-xs text-muted-foreground">
              {option?.availability}
            </p>
          </button>
        ))}
      </div>
      <div className="bg-card border border-border rounded-xl p-8">
        <h3 className="text-2xl font-heading font-bold text-foreground mb-6">
          Submit a Support Ticket
        </h3>
        <form onSubmit={handleSubmitTicket} className="space-y-6">
          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-medium text-foreground mb-2">
                Subject *
              </label>
              <input
                type="text"
                value={ticketForm?.subject}
                onChange={(e) => setTicketForm({ ...ticketForm, subject: e?.target?.value })}
                placeholder="Brief description of your issue"
                required
                className="w-full px-4 py-3 bg-background border border-border rounded-lg text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-foreground mb-2">
                Category *
              </label>
              <select
                value={ticketForm?.category}
                onChange={(e) => setTicketForm({ ...ticketForm, category: e?.target?.value })}
                required
                className="w-full px-4 py-3 bg-background border border-border rounded-lg text-foreground focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary"
              >
                <option value="">Select a category</option>
                <option value="technical">Technical Issue</option>
                <option value="billing">Billing & Subscription</option>
                <option value="account">Account Management</option>
                <option value="ai-agents">AI Agents</option>
                <option value="publishing">Publishing</option>
                <option value="other">Other</option>
              </select>
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              Description *
            </label>
            <textarea
              value={ticketForm?.description}
              onChange={(e) => setTicketForm({ ...ticketForm, description: e?.target?.value })}
              placeholder="Please provide detailed information about your issue..."
              required
              rows={6}
              className="w-full px-4 py-3 bg-background border border-border rounded-lg text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary resize-none"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              Priority
            </label>
            <div className="flex space-x-4">
              {['low', 'normal', 'high', 'urgent']?.map((priority) => (
                <label key={priority} className="flex items-center space-x-2 cursor-pointer">
                  <input
                    type="radio"
                    name="priority"
                    value={priority}
                    checked={ticketForm?.priority === priority}
                    onChange={(e) => setTicketForm({ ...ticketForm, priority: e?.target?.value })}
                    className="w-4 h-4 text-primary focus:ring-primary"
                  />
                  <span className="text-sm text-foreground capitalize">{priority}</span>
                </label>
              ))}
            </div>
          </div>

          <div className="flex items-center justify-between pt-6 border-t border-border">
            <p className="text-sm text-muted-foreground">
              * Required fields
            </p>
            <button
              type="submit"
              className="px-6 py-3 bg-primary text-primary-foreground rounded-lg font-medium hover:bg-primary/90 transition-colors flex items-center space-x-2"
            >
              <span>Submit Ticket</span>
              <Icon name="Send" size={18} />
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ContactSupport;